module.exports = __webpack_public_path__ + "static/media/panDefault.214c56ed.png";